var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_vm._l((_vm.cms.collection),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:`primary_${index}`,tag:"component",class:`${_vm.name}__collection-primary`,attrs:{"cms":{
      ...item,
      color_text: { color: 'inherit' },
      color_hover: { color: 'inherit' },
      color_disabled: { color: 'inherit' },
      color_background: { color: 'transparent' },
      color_gradient: '',
    }}})}),_vm._v(" "),_vm._l((_vm.cms.collection_secondary),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:`secondary_${index}`,tag:"component",class:`${_vm.name}__collection-secondary`,attrs:{"cms":{
      ...item,
      color_text: { color: 'inherit' },
      color_hover: { color: 'inherit' },
      color_disabled: { color: 'inherit' },
      color_background: { color: 'transparent' },
      color_gradient: '',
    }}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }